import bradburyTheme from "../bradburyTheme"

const themeSelector = (_companyName: string) => bradburyTheme

export default themeSelector
